import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable} from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { IGovService } from './igov.service';

@Injectable({
    providedIn: 'root'
})
export class EDELGATEService {

    public headers;

    constructor(
        private http: HttpClient,
        private igvoService: IGovService
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json'});

    }

    getLookup(type) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/e-delegate/getlookups/${type}`, {headers: this.headers});
    }

    getAgendas(currentSession) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/getlookups/getAgendas/${currentSession}`, {headers: this.headers});
    }

    getEdecision(currentDecision) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/decision/getbysession/${currentDecision}`, {headers: this.headers});
    }

    getProposal(query : {session: string, agenda: string, body: string}) {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/getProposal`, {params:query, headers: this.headers});
    }
}
